module.exports = __webpack_public_path__ + "static/media/clusteredIndex.2ba037af.png";